<template>
    <div
        id="whiteboard-toolbar"
        class="toolbar absolute z-[1001] items-center"
        ref="toolbarRef"
        v-if="!props.viewOnly"
    >
        <div class="toolbar-section !px-4" style="flex: 0 0 auto">
            <div
                class="cursor-pointer flex items-center gap-2"
                @touchstart="startMove"
                @mousedown="startMove"
            >
                <img src="/default-images/whiteboard/toolbar-move.svg" />
                <div id="whiteboard-title" class="sep" v-if="props.playName">
                    {{ props.playName }}
                </div>
            </div>
        </div>
        <template v-if="!state.isToolbarCollapsed">
            <AnimationToolbar
                v-if="props.isPlay"
                @action="forwardAnimationAction"
            />
        </template>
        <template v-if="!state.isToolbarCollapsed">
            <div
                class="
                    toolbar-section
                    flex-wrap
                    gap-y-4
                    !items-end
                    !justify-start
                "
                style="flex: 1 1 auto"
                v-if="!!!animation.active"
            >
                <div class="toolbar-wrapper">
                    <div class="toolbar-group">
                        <button type="button" @click="emit('action', 'undo')">
                            <img
                                src="/default-images/whiteboard/tool-undo.svg"
                            />
                        </button>
                        <button type="button" @click="emit('action', 'redo')">
                            <img
                                src="/default-images/whiteboard/tool-redo.svg"
                            />
                        </button>
                        <button
                            type="button"
                            @click="emit('action', 'copy')"
                            v-if="props.isCopyEnabled"
                        >
                            <img
                                src="/default-images/whiteboard/tool-copy.svg"
                                width="20"
                            />
                        </button>
                        <button
                            type="button"
                            @click="emit('action', 'paste')"
                            v-if="props.isPasteEnabled"
                        >
                            <img
                                src="/default-images/whiteboard/tool-paste.svg"
                                width="20"
                            />
                        </button>
                    </div>
                </div>
                <div class="toolbar-wrapper">
                    <div class="toolbar-group">
                        <button
                            type="button"
                            @click="currentTool = 'text'"
                            :class="{ active: currentTool == 'text' }"
                        >
                            <img
                                src="/default-images/whiteboard/tool-text.svg"
                            />
                        </button>
                        <slot name="misc"></slot>
                        <button
                            type="button"
                            @click="toggleMouse()"
                            :class="{ active: currentTool == 'mouse' }"
                        >
                            <img
                                src="/default-images/whiteboard/tool-mouse.svg"
                            />
                        </button>
                    </div>
                </div>

                <div class="toolbar-wrapper">
                    <div class="toolbar-group">
                        <button
                            type="button"
                            @click="isNoteOpen = !isNoteOpen"
                            class="relative"
                            :class="{ active: isNoteOpen }"
                        >
                            <img
                                src="/default-images/whiteboard/tool-note.svg"
                            />
                        </button>
                        <button type="button" @click="emit('action', 'flip')">
                            <img
                                src="/default-images/whiteboard/tool-flip.svg"
                                :style="{
                                    transform:
                                        'scaleX(' +
                                        (state.isFlipped ? -1 : 1) +
                                        ')',
                                }"
                            />
                        </button>
                        <button
                            type="button"
                            @click="
                                currentTool == 'selectArea'
                                    ? (currentTool = '')
                                    : (currentTool = 'selectArea')
                            "
                            class="w-10 h-10"
                            :class="{ active: currentTool == 'selectArea' }"
                        >
                            <img
                                src="/default-images/whiteboard/tool-select-area.png"
                            />
                        </button>
                        <button
                            type="button"
                            @click="emit('action', 'unlock')"
                            class="w-10 h-10 lock-active"
                            v-show="!props.isMultiSelect && isLocked"
                        >
                            <img
                                src="/default-images/whiteboard/tool-lock.png"
                            />
                        </button>
                        <button
                            type="button"
                            @click="emit('action', 'lock')"
                            class="w-10 h-10"
                            v-show="!props.isMultiSelect && !isLocked"
                        >
                            <img
                                src="/default-images/whiteboard/tool-unlock.png"
                            />
                        </button>
                        <button
                            type="button"
                            @click="emit('action', 'ungroup')"
                            class="w-10 h-10"
                            v-show="props.isMultiSelect && props.isGroup"
                        >
                            <img
                                src="/default-images/whiteboard/tool-ungroup.png"
                            />
                        </button>
                        <button
                            type="button"
                            @click="emit('action', 'group')"
                            class="w-10 h-10"
                            v-show="props.isMultiSelect && !props.isGroup"
                        >
                            <img
                                src="/default-images/whiteboard/tool-group.png"
                            />
                        </button>
                        <button
                            type="button"
                            @click="emit('action', 'unlockGroup')"
                            class="w-10 h-10 lock-active"
                            v-show="
                                props.isMultiSelect &&
                                props.isGroup &&
                                props.isGroupLocked
                            "
                        >
                            <img
                                src="/default-images/whiteboard/tool-lock.png"
                            />
                        </button>
                        <button
                            type="button"
                            @click="emit('action', 'lockGroup')"
                            class="w-10 h-10"
                            v-show="
                                props.isMultiSelect &&
                                props.isGroup &&
                                !props.isGroupLocked
                            "
                        >
                            <img
                                src="/default-images/whiteboard/tool-unlock.png"
                            />
                        </button>
                        <button
                            type="button"
                            @click="isConfirmClear = true"
                            v-if="!isConfirmClear"
                        >
                            <img
                                src="/default-images/whiteboard/tool-clear.svg"
                                width="20"
                            />
                        </button>
                        <button
                            type="button"
                            @click="emit('action', 'clear')"
                            v-else
                        >
                            <img
                                src="/default-images/whiteboard/tool-confirm-clear.svg"
                                width="20"
                            />
                        </button>
                    </div>
                </div>

                <div class="toolbar-wrapper flex gap-2">
                    <div v-if="!props.isFree" class="toolbar-group">
                        <button type="button" @click="emit('action', 'ai')">
                            <img src="/default-images/whiteboard/tool-ai.svg" />
                        </button>
                    </div>

                    <div class="toolbar-group">
                        <button
                            type="button"
                            @click="emit('action', 'download')"
                        >
                            <img
                                src="/default-images/whiteboard/tool-download.svg"
                            />
                        </button>
                    </div>

                    <div v-if="props.isPlay" class="toolbar-group">
                        <button
                            type="button"
                            @click="emit('action', 'toggleAnimation')"
                            class="text-[20px] flex items-center"
                        >
                            <ion-icon
                                name="extension-puzzle-outline"
                                width="32"
                            ></ion-icon>
                        </button>
                    </div>
                </div>

                <div class="toolbar-wrapper">
                    <div class="toolbar-group">
                        <ToolbarDropdown>
                            <template v-slot:toggle>
                                <img
                                    :src="`/default-images/whiteboard/tool-size-${
                                        currentSize + 1
                                    }.svg`"
                                    width="30px"
                                />
                            </template>
                            <div
                                class="
                                    bg-white
                                    p-1
                                    flex
                                    gap-2
                                    items-center
                                    justify-center
                                "
                            >
                                <div v-for="n in 3" :key="n">
                                    <div class="toolbar-group">
                                        <button
                                            type="button"
                                            @click="currentSize = n - 1"
                                            :class="{
                                                active: currentSize === n - 1,
                                            }"
                                        >
                                            <img
                                                :src="`/default-images/whiteboard/tool-size-${n}.png`"
                                            />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </ToolbarDropdown>
                        <ColorPicker />
                        <ShapeTool></ShapeTool>
                    </div>
                </div>
                <div class="toolbar-wrapper">
                    <div class="toolbar-group">
                        <PlayerTool
                            :sport="props.sport"
                            @action="emit('action', $event)"
                        />
                        <LineTool :sport="props.sport"></LineTool>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script setup>
import useWhiteboard from "../useWhiteboard";
import { ref, reactive, defineProps, defineEmits, nextTick, watch } from "vue";
const {
    currentTool,
    isConfirmClear,
    currentSize,
    isNoteOpen,
    isLocked,
    animation,
} = useWhiteboard();

const toolbarRef = ref(null);
const props = defineProps([
    "sport",
    "playName",
    "isGuest",
    "viewOnly",
    "isMultiSelect",
    "isGroup",
    "isGroupLocked",
    "isCopyEnabled",
    "isPasteEnabled",
    "isFree",
    "isPlay",
    "previewMode",
]);
const emit = defineEmits(["action"]);

function forwardAnimationAction(...args) {
    emit("action", ...args);
}

const state = reactive({
    isToolbarCollapsed: false,
    isDragging: false,
});

function toggleMouse() {
    if (currentTool.value === "mouse") {
        currentTool.value = "";
    } else {
        currentTool.value = "mouse";
    }
}

watch(
    () => props.previewMode,
    (value) => {
        nextTick(() => {
            const el = toolbarRef.value;
            const whiteboard = document.querySelector("#container.whiteboard");
            console.log(whiteboard.offsetTop);
            el.style.top = whiteboard.offsetTop + "px";
        });
    }
);

function startMove(e) {
    e.preventDefault();
    state.isDragging = true;
    const el = toolbarRef.value;
    let move = 0;

    setTimeout(() => {
        if (move === 0) {
            state.isToolbarCollapsed = !state.isToolbarCollapsed;
        }
    }, 200);

    const whiteboard = document.querySelector("body");

    const toolbarHeight = toolbarRef.value.offsetHeight;
    const toolbarWidth = toolbarRef.value.offsetWidth;
    const maxWidth = whiteboard.offsetWidth - toolbarWidth;
    const maxHeight = whiteboard.offsetHeight - toolbarHeight;

    function mousemove(e) {
        if (!state.isDragging) return;
        e.preventDefault();

        const currentX = e.clientX || e.touches?.[0]?.clientX;
        const currentY = e.clientY || e.touches?.[0]?.clientY;

        const newPos = {
            x: currentX - 80,
            y: currentY - 10,
        };

        if (newPos.x > maxWidth) {
            newPos.x = maxWidth;
        }
        if (newPos.y > maxHeight) {
            newPos.y = maxHeight;
        }

        if (newPos.x < 0) {
            newPos.x = 0;
        }

        if (newPos.y < 0) {
            newPos.y = 0;
        }

        el.style.left = newPos.x + "px";
        el.style.top = newPos.y + "px";
        move++;
    }

    function mouseup() {
        state.isDragging = false;
        window.removeEventListener("mousemove", mousemove);
        window.removeEventListener("touchmove", mousemove);
        window.removeEventListener("mouseup", mouseup);
        window.removeEventListener("touchend", mouseup);
        window.removeEventListener("touchcancel", mouseup);
    }

    window.addEventListener("mousemove", mousemove);
    window.addEventListener("touchmove", mousemove);
    window.addEventListener("mouseup", mouseup);
    window.addEventListener("touchend", mouseup);
    window.addEventListener("touchcancel", mouseup);
}
</script>

<style>
#whiteboard-toolbar {
    position: absolute;
    top: 1px;
    left: 5px;
}
.toolbar-section {
    background: white;
    padding: 12px 6px;
    border-radius: 10px;
    border: 2px solid #e8e8e8;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
}
.toolbar {
    gap: 0.25rem;
    display: flex;
    align-items: flex-start;
    margin-bottom: 10px;
    margin-top: 1px;
    margin-left: 1px;
}
.whiteboard {
    background-size: cover !important;
}
.toolbar button {
    border: none;
    background: none;
    cursor: pointer;
}
.toolbar button.active {
    background: #e2f3fb;
}

#whiteboard-toolbar > div {
    min-height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
}

#whiteboard-toolbar .toolbar-section .toolbar-wrapper {
    padding: 0 15px;
    border-right: 2px dotted #c7c7c7;
}

#whiteboard-toolbar > div:last-child {
    border-right: none;
}
.toolbar-group {
    border-radius: 8px;
    /* border: 2px solid #f6f6f6; */
    display: flex;
    align-items: center;
    position: relative;
}

.toolbar-group > * {
    position: relative;
    border-right: 2px solid #f6f6f6 !important;
    border-top: 2px solid #f6f6f6 !important;
    border-bottom: 2px solid #f6f6f6 !important;
    height: 35px;
    padding-left: 6px;
    padding-right: 6px;
}

.toolbar-group > *:first-child {
    border-left: 2px solid #f6f6f6 !important;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
}

.toolbar-group > *:last-child {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
}

.toolbar button:hover,
.toolbar .button:hover,
.toolbar-group > *:hover {
    background: #e2f3fb;
}

.lock-active {
    background: #f44336a8 !important;
}
.toolbar-wrapper:last-child {
    border-right: none !important;
}
</style>
